import { ErrorBoundary, onMount } from 'solid-js'
import { Dialog } from './components/dialog'
import { Page } from './page'
import { native } from '@forest/native-services'
import { isValidAppVersion } from './lib/params'
import { m } from './paraglide/messages'
import { showDialog } from './store/dialog'

export function App() {
  onMount(() => {
    native.general.pageReady()
    if (!isValidAppVersion) {
      showDialog({
        title: m.dialog_update_version_title(),
        description: m.dialog_update_version_description(),
        primaryButtonText: m.ok(),
        primaryAction: () => {
          native.general.close()
        },
      })
    }
  })
  return (
    <ErrorBoundary fallback={(error) => <div>{error.message}</div>}>
      <Page />
      <Dialog />
    </ErrorBoundary>
  )
}
